import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=126f6d5c&scoped=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"
import style0 from "./Config.vue?vue&type=style&index=0&id=126f6d5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f6d5c",
  null
  
)

export default component.exports